// src/pages/EnergyEfficiency.js 
// (Assuming this file contains your EnergyEfficiency component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; 
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import EEcontent from './PageComponent/EEcontent'

function EnergyEfficiency() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Energy Efficiency | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Discover easy strategies for energy efficiency. Reduce bills and improve your home's comfort. Start saving today!"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/energy-efficiency/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Energy Efficiency" />
                <meta
                    property="og:description"
                    content="Discover easy strategies for energy efficiency. Reduce bills and improve your home's comfort. Start saving today!"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/energy-efficiency/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <EEcontent />
                <Footer />
            </div>
        </>
    );
}

export default EnergyEfficiency;